module.exports = __webpack_public_path__ + "static/media/Garchomp_gaussian2.8a5be8b0.png";